//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Fullpage from './'

export default {
  components: {
    Fullpage
  },
  methods: {
    onChange (data) {
      console.log('chage', data)
    },
    onBeforeChange (data) {
      console.log('before change', data)
    },
    onAfterChange (data) {
      console.log('after change', data)
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/fullpage/DemoBasic.vue